var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 41,
    viewBox: "0 0 26 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54286 37.1683V26.8225H8.54584L8.54267 17.8958L17.8162 17.8922L17.819 25.8708C22.6129 23.8957 26 19.0616 26 13.4112C26 6.00439 20.1797 0 13 0C5.82027 0 0 6.00439 0 13.4112V25.6729V26.8225V37.1683C0 39.2845 1.66296 41 3.71429 41H4.82858C6.87991 41 8.54286 39.2845 8.54286 37.1683ZM15.6472 12.6765C15.5309 12.7571 15.3899 12.8051 15.2342 12.8052L11.1284 12.8068C10.9727 12.8069 10.8317 12.759 10.7154 12.6784L9.08253 16.0544C8.83604 16.564 9.19543 17.1631 9.7475 17.1629L16.6183 17.1602C17.1704 17.1599 17.5294 16.5605 17.2825 16.0511L15.6472 12.6765ZM12.311 8.23824C12.5631 7.60501 13.4323 7.60468 13.685 8.23771L14.4316 10.1084C14.6329 10.6127 14.2736 11.1664 13.7449 11.1665L12.2531 11.1672C11.7245 11.1674 11.3648 10.614 11.5657 10.1096L12.311 8.23824Z",
    fill: "#0445FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.06231b2fc3feed54ed535e624ca14c3b.svg";
export { ForwardRef as ReactComponent };